export default __webpack_public_path__ + "static/media/calendarIconBlue.b87bddb7.svg";